import { render } from "./homeworkManager.vue?vue&type=template&id=6dfa9f3c"
import script from "./homeworkManager.vue?vue&type=script&lang=js"
export * from "./homeworkManager.vue?vue&type=script&lang=js"

import "./homeworkManager.vue?vue&type=style&index=0&id=6dfa9f3c&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__